import { CommonModule } from '@angular/common';
import { Component, Input, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PanelMenuModule } from 'primeng/panelmenu';
import { MenuItem as PrimeMenuItem } from 'primeng/api';
import { LoginService } from '../../services/login.service';

export type CustomMenuItem = {
  icon: string;
  label: string;
  route?: string;
  subItems?: CustomMenuItem[];
};

@Component({
  selector: 'app-sidenav',
  standalone: true,
  imports: [CommonModule, RouterModule, PanelMenuModule],
  template: `
    <div class="sidenav-header">
      <!--<img
        src="assets/brasao-fortaleza.png"
        [width]="profilePicSize()"
        [height]="profilePicSize()"
      />-->
      <div class="header-text" [class.hide-header-text]="sideNavCollapsed()">
        <h2>SICRED</h2>
        <p>Sistema de Credenciais</p>
      </div>
    </div>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <p-panelMenu
      [model]="primeMenuItems()"
      [style]="{ width: '100%' }"
      styleClass="sidenav-menu"
    >
    </p-panelMenu>
  `,
  styles: [
    `
      :host * {
        transition: all 500ms ease-in-out;
      }

      .sidenav-header {
        padding-top: 24px;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
          border-radius: 100%;
          object-fit: contain;
          margin-bottom: 10px;
          object-position: center;
        }

        .header-text {
          text-align: center;
          height: 3rem;

          h2 {
            margin: 0;
            font-size: 1rem;
            line-height: 1.5rem;
            font-weight: 600;
            color: rgb(241, 90, 34);
          }

          p {
            margin: 0;
            font-size: 0.8rem;
            color: rgb(241, 90, 34);
          }
        }
      }

      .hide-header-text {
        height: 0px !important;
        opacity: 0;
      }

      /* PrimeNG PanelMenu Customization */
      :host ::ng-deep .sidenav-menu {
        border: none;
        background: transparent;
      }

      :host ::ng-deep .sidenav-menu .p-panelmenu-panel {
        border: none;
        background: transparent;
        margin-bottom: 0;
      }

      :host ::ng-deep .sidenav-menu .p-panelmenu-header {
        background: transparent;
        border: none;
        border-left: 5px solid rgba(0, 0, 0, 0);
        margin: 0 5px 0.25rem 0;
        padding: 0;
      }

      :host ::ng-deep .sidenav-menu .p-panelmenu-header-content {
        padding: 0.4rem 1rem;
        display: flex;
        align-items: center;
        gap: 0.75rem;
      }

      :host
        ::ng-deep
        .sidenav-menu
        .p-panelmenu-header-content
        .p-menuitem-text {
        font-weight: 700;
      }

      :host ::ng-deep .sidenav-menu .p-panelmenu-header:hover {
        background: rgba(0, 0, 0, 0.05);
      }

      :host ::ng-deep .sidenav-menu .p-panelmenu-header.p-highlight {
        background: rgba(0, 0, 0, 0.05);
        border-left-color: rgb(241, 90, 34);
      }

      :host ::ng-deep .sidenav-menu .p-panelmenu-content {
        border: none;
        background: transparent;
        padding: 0;
        margin: 0 5px 0.25rem 0;
      }

      :host ::ng-deep .sidenav-menu .p-menuitem {
        margin: 0;
      }

      :host ::ng-deep .sidenav-menu .p-menuitem-link {
        color: #495057;
        padding: 0.4rem 1rem;
        border-left: 5px solid rgba(0, 0, 0, 0);
        margin: 0 5px 0 0;
      }

      :host ::ng-deep .sidenav-menu .p-menuitem-link:hover {
        background: rgba(0, 0, 0, 0.05);
      }

      :host ::ng-deep .sidenav-menu .p-menuitem-link.router-link-active {
        background: rgba(0, 0, 0, 0.05);
        border-left-color: rgb(241, 90, 34);
        color: rgb(241, 90, 34);
      }

      :host ::ng-deep .sidenav-menu .p-menuitem-icon {
        color: rgb(241, 90, 34);
        margin-right: 0.5rem;
      }

      :host ::ng-deep .sidenav-menu .p-menuitem-text {
        font-size: 1rem;
        font-weight: 400;
        white-space: nowrap;
        overflow: visible;
        opacity: 1;
        transition: opacity 300ms ease-in-out;
      }

      :host ::ng-deep .sidenav-menu .p-panelmenu-icon {
        font-size: 1.2rem;
        color: rgb(241, 90, 34);
      }

      /* Estilos específicos para sidebar collapsed (50px) */
      :host-context(.sidebar-collapsed)
        ::ng-deep
        .sidenav-menu
        .p-menuitem-text {
        opacity: 0;
        width: 0;
        overflow: hidden;
      }

      :host-context(.sidebar-collapsed)
        ::ng-deep
        .sidenav-menu
        .p-menuitem-link {
        justify-content: center;
        padding: 0.4rem 0;
        margin: 0;
      }

      :host-context(.sidebar-collapsed)
        ::ng-deep
        .sidenav-menu
        .p-menuitem-icon {
        margin-right: 0;
      }

      :host-context(.sidebar-collapsed)
        ::ng-deep
        .sidenav-menu
        .p-panelmenu-header {
        justify-content: center;
        padding: 0;
        margin: 0 0 0.25rem 0;
        border-left: none;
      }

      :host-context(.sidebar-collapsed)
        ::ng-deep
        .sidenav-menu
        .p-panelmenu-header-content {
        justify-content: center;
        padding: 0.4rem 0;
      }

      :host-context(.sidebar-collapsed)
        ::ng-deep
        .sidenav-menu
        .p-panelmenu-header-content
        .p-menuitem-text {
        opacity: 0;
        width: 0;
        overflow: hidden;
      }

      :host-context(.sidebar-collapsed)
        ::ng-deep
        .sidenav-menu
        .p-panelmenu-header-icon {
        margin-right: 0;
      }

      :host-context(.sidebar-collapsed)
        ::ng-deep
        .sidenav-menu
        .p-panelmenu-content {
        margin: 0 0 0.25rem 0;
      }

      :host-context(.sidebar-collapsed)
        ::ng-deep
        .sidenav-menu
        .p-panelmenu-panel {
        margin-bottom: 0;
      }
    `,
  ],
})
export class SidenavComponent {
  sideNavCollapsed = signal(false);
  @Input() set collapsed(val: boolean) {
    this.sideNavCollapsed.set(val);
    this.updatePrimeMenuItems();
  }

  constructor(private loginService: LoginService) {
    this.menuItems();
    this.updatePrimeMenuItems();
  }

  menuItems = signal<CustomMenuItem[]>([
    ...(this.isUser()
      ? [
          {
            icon: 'pi pi-id-card',
            label: 'Emissão',
            route: 'emission',
          },
          {
            icon: 'pi pi-pencil',
            label: 'Cadastro/Alteração',
            subItems: [
              {
                icon: 'pi pi-user',
                label: 'Pessoa',
                route: 'people',
              },
            ],
          },
        ]
      : []),
    {
      icon: 'pi pi-search',
      label: 'Consulta',
      subItems: [
        {
          icon: 'pi pi-id-card',
          label: 'Credencial',
          route: 'credential',
        },
        ...(this.isUser()
          ? [
              {
                icon: 'pi pi-users',
                label: 'Pessoa',
                route: 'peoplesearch',
              },
            ]
          : []),
      ],
    },
    ...(this.isSuperUser()
      ? [
          {
            icon: 'pi pi-chart-bar',
            label: 'Dashboard',
            route: 'dashboard',
          },
        ]
      : []),
    ...(this.isAdmin()
      ? [
          {
            icon: 'pi pi-chart-bar',
            label: 'Resumo',
            route: 'summary',
          },
        ]
      : []),
    ...(this.isAdmin()
      ? [
          {
            icon: 'pi pi-wrench',
            label: 'Administração',
            subItems: [
              {
                icon: 'pi pi-history',
                label: 'Histórico',
                route: 'history',
              },
              {
                icon: 'pi pi-users',
                label: 'Usuários',
                route: 'users',
              },
              {
                icon: 'pi pi-id-card',
                label: 'Cliente Externo',
                route: 'externalclient',
              },
              {
                icon: 'pi pi-id-card',
                label: 'Tipo de Cliente Externo',
                route: 'externalclienttype',
              },
            ],
          },
        ]
      : []),
  ]);

  profilePicSize(): number {
    return this.sideNavCollapsed() ? 32 : 100;
  }

  primeMenuItems = signal<PrimeMenuItem[]>([]);

  private convertToPrimeMenuItems(items: CustomMenuItem[]): PrimeMenuItem[] {
    return items.map((item) => ({
      label: this.sideNavCollapsed() ? '' : item.label,
      icon: item.icon || 'pi pi-circle',
      routerLink: item.route ? [item.route] : undefined,
      items: item.subItems
        ? this.convertToPrimeMenuItems(item.subItems)
        : undefined,
      expanded: false,
      visible: true,
    }));
  }

  private updatePrimeMenuItems() {
    this.primeMenuItems.set(this.convertToPrimeMenuItems(this.menuItems()));
  }

  isAdmin(): boolean {
    const roles = JSON.parse(sessionStorage.getItem('roles') || '[]');
    return roles.includes('ROLE_ADMIN');
  }

  isSuperUser(): boolean {
    const roles = JSON.parse(sessionStorage.getItem('roles') || '[]');
    return roles.includes('ROLE_SUPERUSER');
  }

  isUser(): boolean {
    const roles = JSON.parse(sessionStorage.getItem('roles') || '[]');
    return roles.includes('ROLE_USER');
  }

}
